'use client';
import React__default, { useState, useRef, useEffect } from 'react';

const ElementInView = _ref => {
  let {
    children,
    onInView,
    percentInView = 50
  } = _ref;
  const [isInView, setIsInView] = useState(false);
  const triggerRef = useRef(null);
  const observerRef = useRef(null);
  useEffect(() => {
    if (triggerRef.current) {
      observerRef.current = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= percentInView / 100) {
            setIsInView(true);
            if (onInView) onInView();
            if (observerRef.current && triggerRef.current) {
              observerRef.current.unobserve(triggerRef.current);
            }
          }
        });
      }, {
        threshold: Array.from({
          length: 101
        }, (_, i) => i / 100)
      });
      observerRef.current.observe(triggerRef.current);
    }
    return () => {
      if (observerRef.current && triggerRef.current) {
        observerRef.current.unobserve(triggerRef.current);
      }
    };
  }, [onInView, percentInView]);
  const isRenderProps = typeof children === 'function';
  return /*#__PURE__*/React__default.createElement("div", {
    ref: triggerRef
  }, isRenderProps ? children(isInView) : children);
};

export { ElementInView };
